import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { colors } from "@pepdirect/v3/styles/variables";

export const StyledFooter = styled.div`
  @media ${Device.mobile} {
    width: 100%;
    max-width: 335px;
  }
`;

export const StyledInnerWrapper = styled.div`
  border-top: 1px solid ${colors.gray600};
  padding-top: 20px;

  @media ${Device.mobile} {
    width: 100%;
  }
`;

export const StyledLink = styled.span`
  width: 100%;
  font-size: 14px;

  & * {
    color: ${colors.gray600};
  }

  @media ${Device.mobile} {
    display: block;

    & + * {
      padding-top: 20px;
    }
  }
`;

export const StyledPipe = styled.span`
  padding: 0 6px;

  @media ${Device.mobile} {
    display: none;
  }
`;
